import { BrowserRouter, Routes, Route } from "react-router-dom";
import SiteLayout from "./components/SiteLayout";
import AppErrorBoundary from "./components/AppErrorBoundary";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import ContactPage from "./pages/ContactPage";
import { FALLBACK_SITE_CONTENT, normalizeSiteContent } from "./utils/siteContent";

function App() {
  const siteContent = normalizeSiteContent(FALLBACK_SITE_CONTENT);

  const wrapPage = (pageContent) => (
    <SiteLayout
      contact={siteContent.contact}
      firmName={siteContent.firm_name}
      footerStatement={siteContent.footer_statement}
      navigation={siteContent.navigation}
    >
      {pageContent}
    </SiteLayout>
  );

  return (
    <AppErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={wrapPage(<HomePage content={siteContent} />)} />
          <Route path="/about" element={wrapPage(<AboutPage content={siteContent} />)} />
          <Route path="/services" element={wrapPage(<ServicesPage content={siteContent} />)} />
          <Route path="/contact" element={wrapPage(<ContactPage content={siteContent} />)} />
        </Routes>
      </BrowserRouter>
    </AppErrorBoundary>
  );
}

export default App;
